// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"QASlice_wrapper__93ef7","collapse":"QASlice_collapse__0a431"};